export default __webpack_public_path__ + "static/media/circle.d4d70fde.svg";